// @ts-nocheck

import { StorageActionTypes } from '../types/actions/common';

/**
 * FIXME
 * [description]
 * @param  {[type]} options.options [description]
 * @param  {[type]} options.hooks   [description]
 * @return {[type]}                 [description]
 */
export const storageBasketSave = { type: StorageActionTypes.BASKET_SAVE };

export default {
  storageBasketSave,
};
